
import { defineComponent, onMounted, ref } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  props: {
    slideItems: {
      type: Array,
    },
  },
  setup(props: any) {
    const { commit, dispatch } = useStore()
    const items: any = ref(null)
    const wrapper: any = ref(null)
    const page = ref<number>(0)

    const executeArrow = (path: string) => {
      path === "plus" ? page.value++ : page.value--
      wrapper.value.style.transform = `translate(-${items.value[0].offsetWidth * page.value}px)`
    }

    const closeSlider = () => {
      commit("useinfo/SET_SLIDE_ITEMS", [])
      dispatch("useinfo/openOrCloseSlider")
    }

    onMounted(() => {
      wrapper.value = document.querySelector(".slider-wrapper")
      items.value = document.querySelectorAll(".slide-item")
      wrapper.value.style.width = `${items.value[0].offsetWidth * (props.slideItems.length + 1)}px`
      props.slideItems.forEach((element: any, idx: number) => {
        items.value[idx].style.backgroundImage = `url("${element.image}")`
      })
    })
    return {
      executeArrow,
      page,
      closeSlider,
    }
  },
})
